module.exports = __webpack_public_path__ + "static/media/dreams_of_gold_delight.winfast.d19fa489.jpeg";